import Loading from '@components/Loading';
import colors from '@constants/colors';
import { loadingAtom } from '@states/uiAtoms';
import { useAtomValue } from 'jotai';
import { Fragment } from 'react';

import styles from './styles.module.scss';

function GlobalLoader() {
    const isLoading = useAtomValue(loadingAtom);
    if (isLoading) {
        return (
            <div className={styles.loading}>
                <Loading color={colors.white}/>
            </div>
        );
    }
    return <Fragment/>;
}
export default GlobalLoader;
